import React, { useState, useRef, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const LoginForm = ({ onLogin, isLoading, error }) => {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [validationErrors, setValidationErrors] = useState({});

  // Clear password when component mounts
  useEffect(() => {
    if (passwordRef.current) {
      passwordRef.current.value = '';
    }
  }, []); // Empty dependency array means this runs once when component mounts

  useEffect(() => {
    if (error) {
      if (passwordRef.current) {
        passwordRef.current.value = '';
      }
    }
  }, [error]);

  const handleInputChange = (e) => {
    const { name } = e?.target;
    
    // Clear validation error when user starts typing
    if (validationErrors?.[name]) {
      setValidationErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    const email = emailRef.current?.value || '';
    const password = passwordRef.current?.value || '';
    
    // Email validation (skip since it's pre-filled)
    if (!email.trim()) {
      errors.email = 'E-Mail ist erforderlich';
    }
    
    // Password validation
    if (!password.trim()) {
      errors.password = 'Passwort muss mindestens 6 Zeichen lang sein';
    } else if (password.length < 6) {
      errors.password = 'Passwort muss mindestens 6 Zeichen lang sein';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      const email = emailRef.current?.value || '';
      const password = passwordRef.current?.value || '';
      onLogin({ email, password });
      // Clear the password field after submission
      if (passwordRef.current) {
        passwordRef.current.value = '';
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6" autoComplete="off">
      {/* Email Input */}
      <div className="relative">
        <Input
          label="E-Mail"
          type="email"
          name="email"
          placeholder="Ihre E-Mail-Adresse eingeben"
          ref={emailRef}
          onChange={handleInputChange}
          error={validationErrors?.email}
          required
          disabled={isLoading}
          className="w-full"
          autoComplete="email"
        />
      </div>

      {/* Password Input */}
      <div className="relative">
        <Input
          label="Passwort"
          type="password"
          name="password"
          placeholder="Ihr Passwort eingeben"
          ref={passwordRef}
          onChange={handleInputChange}
          error={validationErrors?.password}
          required
          disabled={isLoading}
          className="w-full"
          autoComplete="new-password"
        />
      </div>
      
      {/* Error Message */}
      {error && (
        <div className="p-3 bg-error/10 border border-error/20 rounded-md">
          <div className="flex items-center space-x-2">
            <Icon name="AlertCircle" size={16} className="text-error" />
            <p className="text-sm text-error">{error}</p>
          </div>
        </div>
      )}
      
      {/* Login Button */}
      <Button
        type="submit"
        variant="default"
        size="lg"
        loading={isLoading}
        disabled={isLoading}
        fullWidth
        iconName="LogIn"
        iconPosition="left"
        iconSize={20}
      >
        {isLoading ? 'Anmeldung läuft...' : 'Anmelden'}
      </Button>
    </form>
  );
};

export default LoginForm;